/**
 * telaCorrente — espelho de onde a pessoa está, legível de QUALQUER lugar.
 *
 * POR QUE NÃO `useShell()`: o contexto do shell só existe dentro do `AppShell`.
 * O relato de bug precisa saber a tela também no login, no `/StepColeta`, no
 * `FormsObjetivo` e no funil `/assinar` — rotas de react-router montadas FORA
 * do provider. E precisa ser legível de um callback nativo (a detecção de
 * print), que não é um componente React e não tem contexto nenhum.
 *
 * POR QUE NÃO `logScreenView`: ele é write-only, vai para o analytics e é
 * chamado ad hoc por meia dúzia de telas. Não dá para ler de volta.
 *
 * Custo: um objeto de módulo e um `useEffect` de uma linha no AppShell. Sem
 * estado de React, sem re-render, sem listener.
 */

const estado = {
  aba: null,
  pilha: [],
  // Dados da sub-tela do topo (ids de documento em foco). Guardado cru; quem
  // monta o relato é que recorta.
  dadosTopo: null,
};

/** Atualiza a parte que vem do AppShell (aba + pilha de sub-telas). */
export function registrarShell({ aba, pilha }) {
  estado.aba = aba || null;
  estado.pilha = Array.isArray(pilha) ? pilha.map((p) => p?.tela).filter(Boolean) : [];
  const topo = Array.isArray(pilha) && pilha.length ? pilha[pilha.length - 1] : null;
  estado.dadosTopo = topo?.dados ?? null;
}

/**
 * Rota lida na hora. Não há listener de router de propósito: o pathname já é a
 * verdade e ler `window.location` custa nada — um subscribe seria código a mais
 * para chegar ao mesmo valor.
 */
function rotaAtual() {
  if (typeof window === 'undefined') return null;
  return window.location?.pathname || null;
}

/**
 * Nome legível da tela corrente: a sub-tela do topo vence a aba, que vence a
 * rota. É a ordem em que a pessoa entende "onde eu estava".
 */
export function telaCorrente() {
  if (estado.pilha.length) return estado.pilha[estado.pilha.length - 1];
  if (estado.aba) return estado.aba;
  return rotaAtual() || 'desconhecida';
}

/** Cópia rasa do estado, para o contexto do relato. */
export function instantaneo() {
  return {
    rota: rotaAtual(),
    aba: estado.aba,
    pilha: [...estado.pilha],
    dadosTopo: estado.dadosTopo,
  };
}
